/**
 * `/studio/clients/$slug/connect/$widgetRef` — the Connect page for one client's hosted
 * widget, on the studio's door (`.docs/46-blog-and-forms.md` §7, decision 12).
 *
 * The blog workspace's sibling and its shape (`$slug_/blog/$widgetRef/`): under the
 * client's address, and **not nested** in the client page — `$slug_` is TanStack's way
 * of saying so, because the client page is a leaf with no outlet. A manager's, like
 * every studio page `auth/guards.ts` `STUDIO_ROUTE_ROLE` does not name; the `hooks_*`
 * actions the page calls are a manager's at the registry too.
 */

import { isRef } from '@fareast/shared'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { NotFound } from '../../../../../errors/NotFound.js'
import { parseConnectSearch } from '../../../../../pages/connect/search.js'
import { StudioConnectPage } from '../../../../../pages/connect/StudioConnectPage.js'

export const Route = createFileRoute('/studio/clients/$slug_/connect/$widgetRef')({
  beforeLoad: ({ params }) => {
    if (!isRef('client', params.slug)) throw notFound()
  },
  /** `?example=curl|fetch` — how the examples are written, which the page writes. */
  validateSearch: parseConnectSearch,
  /** R3-13: the boundary is this route, so the studio shell outlives the refusal. */
  notFoundComponent: NotFound,
  component: ConnectRoute,
})

function ConnectRoute() {
  const { slug, widgetRef } = Route.useParams()
  return <StudioConnectPage slug={slug} widgetRef={widgetRef} />
}
